<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">

                <template>
                  <div>
                    <v-alert
                      v-for="notification in notifications.web_sales"
                      :key="`web-sale-${notification.id}`"
                      type="success"
                      border="left"
                      prominent
                    >
                      <strong>Nueva venta web</strong><br>

                      Se registró una venta de
                      <strong>{{ notification.name }}</strong>
                      con número
                      <strong>{{ notification.phone }}</strong>.

                      <br>

                      <strong>Fecha de compra:</strong>
                      {{ formatDate(notification.created_at) }}

                      <br>

                      <strong>Fecha de entrega:</strong>
                      {{ formatDate(notification.delivery_day) }}

                      <br>

                      <strong>Total:</strong>
                      S/ {{ notification.total }}

                      <div class="mt-3">
                        <v-btn
                          small
                          outlined
                          color="white"
                          @click="goToDeliveryCalendar(notification)"
                        >
                          <v-icon left small>
                            mdi-eye
                          </v-icon>
                          Ver pedido
                        </v-btn>
                      </div>
                    </v-alert>

                    <v-alert
                      v-for="notification in notifications.bags"
                      :key="notification.id"
                      :type="notification.notification_type === 'expired' ? 'error' : 'warning'"
                      border="left"
                      prominent
                    >
                      <div v-if="notification.notification_type === 'expired'">
                        <strong>Bolsa expirada</strong><br>

                        La bolsa de <strong>{{ notification.name }}</strong>
                        con número <strong>{{ notification.phone }}</strong>
                        expiró el
                        <strong>{{ formatDate(notification.expiration_date) }}</strong>
                        y tiene un saldo pendiente de
                        <strong>S/ {{ notification.pending_payment }}</strong>.

                        <div class="mt-3">
                          <v-btn
                            small
                            outlined
                            color="white"
                            @click="copyExpiredMessage(notification)"
                          >
                            <v-icon left small>mdi-content-copy</v-icon>
                            Copiar mensaje
                          </v-btn>
                        </div>
                      </div>

                      <div v-else>
                        <strong>Bolsa próxima a expirar</strong><br>

                        La bolsa de <strong>{{ notification.name }}</strong>
                        con número <strong>{{ notification.phone }}</strong>
                        vence el
                        <strong>{{ formatDate(notification.expiration_date) }}</strong>
                        y tiene un saldo pendiente de
                        <strong>S/ {{ notification.pending_payment }}</strong>.
                      </div>
                    </v-alert>
                  </div>
                </template>

              </v-col>
            </v-row>
          </template>
        </div>
      </template>


      <template>
        <v-snackbar
          v-model="snackbar"
        >
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="pink"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import moment from 'moment'
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import {
    formatDate,
  } from '@/utils/notification/index'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  export default {
    name: 'InicioView',
    components: {
      DefaultLayout
    },
    data () {
      return {
        overlay: false,
        // ************ snackbar ************
        notifications: {
          bags: [],
          web_sales: []
        },
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    methods: {
      formatDate,
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      getNotifications() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.LIST_NOTIFICATIONS)
        .then(response => {
          this.notifications = response.data;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getExpiredWhatsAppMessage(notification) {
        const maxPaymentDate = this.formatDate(
          moment().add(3, 'days')
        );

        return `Hola, su bolsita aperturada el *${this.formatDate(notification.opening_date)}* ya excedió los *14 días de plazo*, la fecha de expiración fue el *${this.formatDate(notification.expiration_date)}*. El plazo máximo para cancelar su(s) producto(s) es hasta el *${maxPaymentDate}*, caso contrario su(s) producto(s) serán liberados.`;
      },

      async copyExpiredMessage(notification) {
        const message = this.getExpiredWhatsAppMessage(notification);

        try {
          await navigator.clipboard.writeText(message);

          this.showMessage(
            'Mensaje copiado al portapapeles',
            'success'
          );
        } catch (error) {
          console.error(error);

          this.showMessage(
            'No se pudo copiar el mensaje',
            'error'
          );
        }
      },

      goToDeliveryCalendar(notification) {
        this.$router.push({
          name: 'Order',
          query: {
            orderId: notification.id
          }
        }).catch(() => {});
      },

      logout: function() {
        localStorage.clear();
        window.location.href = "/";
      }
    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getNotifications();
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Inicio.vue